<template>
  <div>
    <div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input placeholder="活动名称" v-model="params.title"><el-button slot="append" icon="el-icon-search" @click="dataSearch"></el-button></el-input>
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="create_time" type="daterange" value-format="yyyy/MM/dd" placeholder="添加时间筛选" style="width: 100%;" @change="dateChange"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" icon="plus" @click="setActivityUsers" >添加指定用户</el-button>
        </el-col>
      </el-row>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="all"></el-tab-pane>

        <el-table :data="activityLists" :height="wheight-200" v-loading="loading">
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="activity_id" label="活动id" min-width="60"></el-table-column>
          <el-table-column prop="user_id" label="用户id" min-width="80"></el-table-column>
          <el-table-column  label="领取状态" min-width="60">
              <template slot-scope="scope">
                <span v-if="scope.row.status == '1'" type="primary">已领取</span>
                <span v-else type="primary">未领取</span>
              </template>
          </el-table-column>
          <el-table-column label="创建时间" min-width="150">
            <template slot-scope="scope">
              <div> {{scope.row.create_time | datetime('yyyy-MM-dd hh:mm:ss')}}</div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="250">
            <template slot-scope="scope">

              <el-button v-if="scope.row.status != '1'" type="text" @click="delUserAction(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="total_count > params.pageSize" class="content-center content-top-padded">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-sizes="[10,20,50]"
            :current-page.sync="params.page"
            :total="total_count" :page-size="params.pageSize">
          </el-pagination>
        </div>
      </el-tabs>
    </div>

    <!--<el-dialog title="添加活动人员" :visible.sync="dialogVisible" width="50%">-->
      <!--<el-table :data="distributors.distributor_info" :height="wheight-500" v-loading="loading">-->
        <!--<el-table-column prop="mobile" label="用户手机" min-width="180"></el-table-column>-->
        <!--<el-table-column prop="user_id" label="用户id" min-width="180"></el-table-column>-->
        <!--<el-table-column label="操作" width="250">-->

        <!--</el-table-column>-->
      <!--</el-table>-->
    <!--</el-dialog>-->
    <UserSelect :user-visible="dialogVisible" :is-valid="true"  :loading-check="loading_check" @chooseUser="chooseUserAction" @closeUserDialog="closeUserDialog"></UserSelect>

    <router-view></router-view>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'
import UserSelect from '@/components/userselect'
import { getGiftsActivitysList,getGiftsActivityUser,setGiftsActivityUser,delGiftActivityUser} from '../../../../api/promotions'
export default {
  props: ['getStatus'],
  components: {
      UserSelect
  },
  provide() {
    return {
      refresh: this.refresh
    }
  },
  data () {
    return {
      create_time: '',
      activeName: 'all',
      activityLists: [],
      downloadfilename: '',
      choseactivity_id:'',
      downloadUrl: '',
      loading: false,
      total_count: 0,
      params: {
        page: 1,
        pageSize: 20,
        title: '',
        begin_time: '',
        end_time: '',
      },
      select_activity_id:'',
      communityVisible: false,
      couponVisible: false,
      goodsVisible: false,
      goodsList: [],
      goodsCount: 0,
      distributors: [],
      goodsPageSize: 10,
      goodsPage:1,
      nowActivity: '',
      cursymbol: '',
      dialogVisible: false,
      loading_check: false,
      currency: {}
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {

    handleClick(tab, event) {
      this.activeName = tab.name
      this.params.status = tab.name == 'all' ? '' : tab.name
      this.params.page = 1
      this.getActivityLists()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getActivityLists()
    },
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getActivityLists()
    },
    delUserAction (index, row) { // 编辑物料弹框
        let del_id = row.id
        const _this = this
        this.$confirm('确认删除当前用户权益？').then(_ => {
            delGiftActivityUser(del_id).then(res => {
                if (res.data.data.status) {
                    this.$message({
                        message: '删除成功',
                        type: 'success',
                    })
                }else{
                    this.$message({
                        message: '删除失败',
                        type: 'error',
                    })
                }
            })
            _this.getActivityLists()
        })
    },
    setActivityUsers() {
      if(this.select_activity_id == ''){
          alert('请在0元购中选择活动，再选择人员')
          return
      }
      this.dialogVisible = true;
    },
    getActivityUsers(index){
        // 获取领取商品人数
        this.$router.push({path: this.matchHidePage('editor/') + index.id})
    },
    // 选择用户 插件 ===
    closeUserDialog() {
      this.dialogVisible = false
    },
      // 选择后操作
    chooseUserAction(data){
        this.loading_check = true
        this.loading = true
        let user_id = data.user_id
        console.log(user_id,'user_id')
        // 增加记录
        setGiftsActivityUser({'user_id':user_id,'activity_id':this.select_activity_id}).then(response => {
            let add_status = response.data.data.status
            if(add_status){
                // 添加成功
                this.$message({
                    message: '添加成功',
                    type: 'success',
                    duration: 2 * 1000,
                })
            }else{
                // 失败
                this.$message({
                    message: '添加失败',
                    type: 'error',
                    duration: 2 * 1000,
                })
            }
            this.closeUserDialog()
            this.loading = false
            this.loading_check = false
            this.getActivityLists()
        })
    },
    // 选择用户 插件 ===
    dataSearch() {
      this.params.begin_time = ''
      this.params.end_time = ''
      this.params.page = 1
      this.getActivityLists()
    },
    getActivityLists () {
      this.loading = true
        if(this.$route.query.activity_id) {
            this.params.activity_id = this.$route.query.activity_id
            this.select_activity_id = this.$route.query.activity_id
        }
        getGiftsActivityUser(this.params).then(response => {
        this.activityLists = response.data.data.list
        this.total_count = response.data.data.total_count
        this.loading = false
      })
    },
    dateChange (val) {
      this.params.status = ''
      if (val && val.length > 0) {
        this.params.begin_time = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
        this.params.end_time = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
      } else {
        this.params.begin_time = ''
        this.params.end_time = ''
      }
      this.params.page = 1
      this.getActivityLists()
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    viewCouponList(ids){
      this.couponVisible = true
    },
    handleCancel () {
      this.communityVisible = false
      this.couponVisible = false
      this.goodsVisible = false
    },

    refresh () {
      this.getActivityLists()
    }
  },
  mounted () {
    this.getActivityLists()
  },
  watch: {
    getStatus (val) {
      if (val) {
        this.getActivityLists()
      }
    }
  }
}
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.icon-search-plus {
  cursor: pointer;
}
.text-muted {
  color: #999;
}
</style>



// WEBPACK FOOTER //
// userlimit.vue?e70e6d76